<div class="weather-widget">
  <div class="header" *ngIf="formattedWeatherData">
    <div class="location-info">
      <div class="location-label">{{ 'WIDGETS.WEATHER.LOCATION' | translate }} :</div>
      <div class="location-name">{{ formattedWeatherData.location }}</div>
    </div>
  </div>

  <div class="forecast-container" *ngIf="formattedWeatherData && formattedWeatherData.forecasts.length > 0">
    <!-- Today -->
    <div class="forecast-column">
      <div class="day-header">{{ 'WIDGETS.WEATHER.TODAY' | translate }}</div>
      <div class="forecast-content">
        <div class="temp-icon-group">
          <div class="forecast-temp">
            {{ formattedWeatherData.forecasts[0].highTemperature | temperature }}
          </div>

          <div class="forecast-icon-container">
            <img [src]="formattedWeatherData.forecasts[0].icon" class="forecast-icon" />
          </div>

          <div class="forecast-condition">
            {{ formattedWeatherData.forecasts[0].condition }}
          </div>

          <div class="forecast-temp">
            {{ formattedWeatherData.forecasts[0].lowTemperature | temperature }}
          </div>
        </div>

        <div class="forecast-details">
          <div class="forecast-time">
            <img src="assets/images/weather/sunrise.png" class="small-icon" />
            <span>{{ formattedWeatherData.forecasts[0].sunrise | timeFormat: locale }}</span>
          </div>
          <div class="forecast-time">
            <img src="assets/images/weather/sunset.png" class="small-icon" />
            <span>{{ formattedWeatherData.forecasts[0].sunset | timeFormat: locale }}</span>
          </div>
          <div class="forecast-humidity">
            <img src="assets/images/weather/humidity.png" class="small-icon" />
            <span>{{ formattedWeatherData.forecasts[0].humidity }}%</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Next 4 Days -->
    <div *ngFor="let forecast of formattedWeatherData.forecasts.slice(1, 5); let i = index" class="forecast-column">
      <div class="day-header">{{ i + 1 | dayName: locale }}</div>
      <div class="forecast-content">
        <div class="temp-icon-group">
          <div class="forecast-temp">
            {{ forecast.highTemperature | temperature }}
          </div>

          <div class="forecast-icon-container">
            <img [src]="forecast.icon" class="forecast-icon" />
          </div>

          <div class="forecast-condition">
            {{ forecast.condition }}
          </div>

          <div class="forecast-temp">
            {{ forecast.lowTemperature | temperature }}
          </div>
        </div>

        <div class="forecast-details">
          <div class="forecast-time">
            <img src="assets/images/weather/sunrise.png" class="small-icon" />
            <span>{{ forecast.sunrise | timeFormat: locale }}</span>
          </div>
          <div class="forecast-time">
            <img src="assets/images/weather/sunset.png" class="small-icon" />
            <span>{{ forecast.sunset | timeFormat: locale }}</span>
          </div>
          <div class="forecast-humidity">
            <img src="assets/images/weather/humidity.png" class="small-icon" />
            <span>{{ forecast.humidity }}%</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="loading-state" *ngIf="!formattedWeatherData">{{ 'WIDGETS.WEATHER.LOADING' | translate }}</div>
</div>
